import { render, staticRenderFns } from "./SampleDemo.vue?vue&type=template&id=72be7add&scoped=true&"
import script from "./SampleDemo.vue?vue&type=script&lang=js&"
export * from "./SampleDemo.vue?vue&type=script&lang=js&"
import style0 from "./SampleDemo.vue?vue&type=style&index=0&id=72be7add&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72be7add",
  null
  
)

export default component.exports